var $slider = $(".event_slider");

if ($slider.length) {
  var currentSlide;
  var slidesCount;
  var sliderCounter = document.createElement("div");
  sliderCounter.classList.add("slider__counter");

  var updateSliderCounter = function (slick, currentIndex) {
    currentSlide = slick.slickCurrentSlide() + 1;
    slidesCount = slick.slideCount;
    $(sliderCounter).text(currentSlide + "/" + slidesCount);
  };

  $slider.on("init", function (event, slick) {
    $slider.append(sliderCounter);
    updateSliderCounter(slick);
  });

  $slider.on("afterChange", function (event, slick, currentSlide) {
    updateSliderCounter(slick, currentSlide);
  });

  $slider.slick({
    autoplay: false,
    autoplaySpeed: 3000,
    infinite: true,
    arrows: true,
    slidesToShow: 4,
    // centerMode: true,
    centerPadding: "40px", // Corrected the property name
    slidesToScroll: 1, // Corrected the property name
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  });
   $slider.on('setPosition', function (event, slick) {
	slick.$slides.css('height', slick.$slideTrack.height() + 'px');
});
}



// product page sider

var $slider = $(".images_perents");

if ($slider.length) {
  var currentSlide;
  var slidesCount;
  var sliderCounter = document.createElement("span");
  sliderCounter.classList.add("slider__counter");

  var updateSliderCounter = function (slick, currentIndex) {
    currentSlide = slick.slickCurrentSlide() + 1;
    slidesCount = slick.slideCount;
    $(sliderCounter).text(currentSlide + "/" + slidesCount);
  };

  $slider.on("init", function (event, slick) {
    $slider.append(sliderCounter);
    updateSliderCounter(slick);
  });

  $slider.on("afterChange", function (event, slick, currentSlide) {
    updateSliderCounter(slick, currentSlide);
  });

  $slider.slick({
    autoplay: false,
    autoplaySpeed: 3000,
    infinite: true,
    arrows: true,
    slidesToShow: 4,
    // centerMode: true,
    centerPadding: "40px", // Corrected the property name
    slidesToScroll: 1, // Corrected the property name
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
        }
      }
    ]
  });
   $slider.on('setPosition', function (event, slick) {
	slick.$slides.css('height', slick.$slideTrack.height() + 'px');
});
}








// $(document).ready(function() {
  
//   function checkWindowSize() {
//     if ($(window).width() < 998) {
//       $('.images_perents').addClass('images_perents1');
//     } else {
//       $('.images_perents').removeClass('images_perents1');
//     }
//   }

  
//   checkWindowSize();

  
//   $(window).resize(function() {
//     checkWindowSize();
//   });
// });



// story page slider
var $slider = $(".journey_parent");

if ($slider.length) {
  var currentSlide;
  var slidesCount;
  var sliderCounter = document.createElement("span");
  sliderCounter.classList.add("slider__counter");

  var updateSliderCounter = function (slick, currentIndex) {
    currentSlide = slick.slickCurrentSlide() + 1;
    slidesCount = slick.slideCount;
    $(sliderCounter).text(currentSlide + "/" + slidesCount);
  };

  $slider.on("init", function (event, slick) {
    $slider.append(sliderCounter);
    updateSliderCounter(slick);
  });

  $slider.on("afterChange", function (event, slick, currentSlide) {
    updateSliderCounter(slick, currentSlide);
  });

  $slider.slick({
    autoplay: false,
    autoplaySpeed: 3000,
    infinite: true,
    arrows: true,
    slidesToShow: 3,
    // centerMode: true,
    centerPadding: "40px", // Corrected the property name
    slidesToScroll: 1, // Corrected the property name
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  });
   $slider.on('setPosition', function (event, slick) {
	slick.$slides.css('height', slick.$slideTrack.height() + 'px');
});
}



// redirect button
// Function to scroll down the window smoothly
function scrollDown() {
    window.scrollTo({
        top: document.body.scrollHeight,
        behavior: 'smooth'
    });
}

// Attach click event listeners to all elements with the class "banner_button"
var buttons = document.getElementsByClassName('banner_button');
for (var i = 0; i < buttons.length; i++) {
    buttons[i].addEventListener('click', function(event) {
        event.preventDefault(); // Prevent the default behavior of the anchor tag

        console.log('Button clicked!');

        // Your additional click event handling code here
        
        // Select the footer content
        var footerContent = document.getElementsByClassName('footer-block__details-content')[1];
        
        // Find all <li> tags within the selected element
        var liElements = footerContent.querySelectorAll('li');
        
        var fourthLi = liElements[3]; // Get the fourth <li> element
        
        // Find the <a> tag within the fourth <li> element
        var anchorTag = fourthLi.querySelector('a');
        
        // Add the class "highlighted" to the <a> tag
        anchorTag.classList.add('highlighted');
        
        console.log(anchorTag); // Log the <a> tag

        // Scroll down the window
        scrollDown();
    });
}